import Button from "@/common/components/Button";
import Modal from "@/common/components/Modal";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import useCreateClientUserExternalToken from "@/features/privateCompanies/hooks/users/useCreateClientUserExternalToken";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

interface CreateClientUserTokenModalProps {
  clientUserId?: string;
}

const CreateClientUserTokenModal = ({ clientUserId }: CreateClientUserTokenModalProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState<string[] | boolean>(false);

  const queryClient = useQueryClient();

  const {
    mutate: createClientUserExternalToken,
    isPending: createClientUserExternalTokenIsPending,
    isError: createClientUserExternalTokenIsError,
  } = useCreateClientUserExternalToken({
    clientUserId,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clientUserExtenalTokens', clientUserId] });
      setIsOpen(false);
      setMessages(['Token gerado com sucesso!']);
    },
    onError: (e) => {
      setIsOpen(false);
      setMessages(e.response?.data?.errors?.base || ['Ocorreu um erro ao gerar token']);
    }
  })

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        Trigger={(
          <Button
            name="create_client_user_external_token"
            operationKlassToCheckPermission="Admin::Client::UserExternalTokens::Create"
          >
            Gerar token
          </Button>
        )}
        title="Confirmar geração de Token"
        subtitle="Você tem certeza que deseja gerar um novo token?"
        titleClass="text-2xl"
        subtitleClassName="mt-1 text-white-400"
        showClose={false}
        useCancellableFooter
        confirmButtonClassName="bg-blue-700 disabled:opacity-70"
        confirmButtonIsLoading={createClientUserExternalTokenIsPending}
        onConfirm={createClientUserExternalToken}
      />

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={createClientUserExternalTokenIsError}
        />
      )}
    </>
  )
}

export default CreateClientUserTokenModal;
